import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from './api';
import { useRole } from './role';

/** «Выйти»: сессия закрыта, роль, объект и кэш запросов прежнего пользователя забыты, дальше — страница входа. */
export function useLogout(): () => Promise<void> {
  const { clearSelection } = useRole();
  const navigate = useNavigate();
  return useCallback(async () => {
    await api.logout().catch(() => {});
    clearSelection();
    navigate('/login');
  }, [clearSelection, navigate]);
}
